import { getApiKey } from "../../../utils/apiKey";
import React from "react";
import { apiCall_domainV2 } from "../../api";
import CountDown from "../ClubKachar/CountDown";
import Spinner from "../../Spinner/Spinner";
import axios from "axios";
import Header from "../../header";

export class HistoryPage extends React.Component {
  state = {
    activeTab: 1,
    infoModal: false,
    myBazarcheHistory: [],
    myLotteryHistory: [],
    loading: true,
  };

  changeTap = (tab) => {
    this.setState({ activeTab: tab });
  };
  // api call
  componentWillMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market/history?type=2`, {
        headers,
      })
      .then((res) => {
        this.setState({ loading: false, myBazarcheHistory: res.data });
      })
      .catch((err) => {});
    axios
      .get(`${apiCall_domainV2}/customer/market/history?type=1`, {
        headers,
      })
      .then((res) => {
        this.setState({ loading: false, myLotteryHistory: res.data.data });
      });
  }
  backBtn = () => {
    this.props.history.goBack();
  };

  render() {
    const myBazarche = this.state.activeTab === 2 ? "myBazarcheActive" : "";
    const myLottary = this.state.activeTab === 1 ? "myLottaryActive" : "";
    return this.state.loading ? (
      <Spinner />
    ) : (
      <>
        <Header
          showSearchBar={true}
          title="تاریخچه"
          changeDetail={true}
          isDarkTheme={true}
        />
        <div className="clubHistroyContainer">
          <div className="historyTabs">
            <span
              className={myLottary}
              onClick={() => {
                this.changeTap(1);
              }}
            >
              قرعه کشی های من
            </span>
            <span
              className={myBazarche}
              onClick={() => {
                this.changeTap(2);
              }}
            >
              بازارچه من
            </span>
          </div>
          {this.state.activeTab === 1 &&
            (this.state.myBazarcheHistory?.current_lottery ||
              this.state.myBazarcheHistory?.expired_lotteries) && (
              <>
                <div className="historyBody">
                  {this.state.myBazarcheHistory.current_lottery && (
                    <div className="currentLottary">
                      <div className="lottaryDetail">
                        <h3>
                          قرعه کشی
                          {this.state.myBazarcheHistory.current_lottery.title}
                        </h3>
                        <div>
                          <span>کل امتیازات مصرف شده</span>
                          <span>
                            {
                              this.state.myBazarcheHistory.current_lottery
                                .customer_details.points
                            }
                          </span>
                        </div>
                        <div>
                          <span>تعداد شانس ها</span>
                          <span>
                            {
                              this.state.myBazarcheHistory.current_lottery
                                .customer_details.chances_count
                            }
                          </span>
                        </div>
                      </div>
                      <div className="timer">
                        <span>
                          {this.state.myBazarcheHistory.current_lottery.title}
                        </span>
                        <span>
                          {
                            this.state.myBazarcheHistory.current_lottery
                              .description
                          }
                        </span>
                        <span className="countdown">
                          <CountDown
                            expire_time={
                              this.state.myBazarcheHistory.current_lottery
                                .expire_time
                            }
                          />
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="historyDivs pastLottaryDivs">
                    {this.state.myBazarcheHistory.expired_lotteries.length ? (
                      this.state.myBazarcheHistory?.expired_lotteries.map(
                        (item) => {
                          return (
                            <div className="historyDiv pastLottary">
                              <div className="historyDivBody">
                                <h3>{item.title}</h3>
                                <div>
                                  <div>
                                    <span>کل امتیازات مصرف شده</span>
                                    <span>{item.status}</span>
                                  </div>
                                  <div>
                                    <span>تعداد شانس های شرکت در قرعه کشی</span>
                                    <span>شانس {item.customer_details}</span>
                                  </div>
                                </div>
                                <div>
                                  <span>تاریخ قرعه کشی</span>
                                  <span>{item.lottery_time}</span>
                                </div>
                              </div>
                              <div>
                                {item.is_winner
                                  ? `${item.award}`
                                  : `${item.status}`}
                              </div>
                            </div>
                          );
                        },
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </>
            )}
          {this.state.activeTab === 2 && (
            <div className="historyDivs">
              {this.state.myLotteryHistory.length ? (
                this.state.myLotteryHistory.map((item) => {
                  return (
                    <div className="historyDiv">
                      <div className="historyDivBody">
                        <h3>{item.title}</h3>
                        <div>
                          <p>{item.text}</p>
                          <span>
                            <span>
                              اعتبار تا
                              <span>{item.expire_time}</span>
                            </span>
                          </span>
                        </div>
                        <div>
                          <span>
                            {item.required_points}
                            <img src="/public/assets/coin.svg" alt="coin " />
                          </span>
                        </div>
                      </div>
                      <div>{item.code}</div>
                    </div>
                  );
                })
              ) : (
                <span className="noDataMsg">هنوز اطلاعاتی وجود ندارد</span>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}
